module.exports = __webpack_public_path__ + "img/back.290174b6.svg";